/* eslint-disable no-var */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import FabricCanvasExercise, { Props } from '../fabricexercise';
import { uuid4 } from '../../utils';
import { fabric } from '@/@corefabriccanvas/fabric/dist/fabric';
import { defineExerciseType, Type, drawCircle } from '../utils';
import { PageIcon, PageItemCanvasModel } from '@/types';
class Matching extends FabricCanvasExercise {
  Type = {
    OneToOne: '1-1',
    OneToMany: '1-N',
    ManyToMany: 'N-N',
  };
  pageItem: PageItemCanvasModel | undefined;
  matchingItems: any[] = [];
  activityType: any;
  currentPageItem!: PageItemCanvasModel;
  targets: any[] = [];
  sources: any[] = [];
  activityBackgroundImage: string | undefined;
  async configureCanvas(props: Props) {
    this.pageItem = props.currentPageItem;
    this.matchingItems = [];
    this.activityType = props.currentPageItem.exerciseType;
    this.currentPageItem = props.currentPageItem;
    this.currentPageItem = props.currentPageItem;
    this.activityBackgroundImage = props.activityBackgroundImage;

    if (this.pageItem && this.pageItem.sources) {
      this.sources = await this.addSources(this.pageItem.sources);
    }
    if (this.pageItem && this.pageItem.targets) {
      this.targets = await this.addTargets(this.pageItem.targets);
    }

    const checkPosition = this.checkPosition;
    const createMatchingLine = this.createMatchingLine;
    // kaynak elemanların sürükleme özelliklerinin ayarlanması
    const canvas = this._canvas;
    let line = this.line;
    const openDrawingMode= this.openDrawingMode;
    const closeDrawingMode = this.closeDrawingMode;
    const selectedTool = this.selectedTool;
    this.sources.forEach(function (source) {
      console.log(source);
      source.set('draggable', true);

      source.on('mousedown:before', (o: any) => {
        closeDrawingMode(canvas,selectedTool);
        line = createMatchingLine(source);
      });
      source.on('mousedown', function () {
        canvas.bringToFront(source);
        source.set({ opacity: 0 });
        canvas.addObject(line);
      });
      source.on('drag', function () {
        canvas.canvasRenderAll();
      });
      source.on('mouseup', function (e: any) {
        checkPosition(source, line, e.pointer.x, e.pointer.y);
        openDrawingMode(canvas,selectedTool);

      });
    });

    // hedef elemanların bırakma özelliklerinin ayarlanması

    canvas.on('object:moving', function (event: any) {
      if (line) {
        line.set({ x2: event.pointer.x, y2: event.pointer.y });
        line.setCoords();
        canvas.canvasRenderAll();
      }
    });

    // kaynak elemanların orijinal pozisyonunun kaydedilmesi
    this.sources.forEach(function (source) {
      source.originalLeft = source.left;
      source.originalTop = source.top;
    });

    // this.renderActivityFiles(props, opts);
  }
  getRandomColor() {
    return `hsla(${Math.random() * 360}, 100%, 50%, 1)`;
  }

  addSources = async (sources: PageIcon[]) => {
    const sourceList = [];
    const sourceOptions = sources;
    let index = 0;
    const imageCoordinate = this._canvas.getBackgroundImageCoordinate();
    for (const o of sourceOptions) {
      const left = imageCoordinate.imgLeft + o.x;
      const top = imageCoordinate.imgTop + o.y;
      const source = new fabric.Rect({
        width: o.width,
        height: o.height,
        strokeWidth: 3,
        pageIcon: true,
        rx: 8,
        ry: 8,
        shadow: 'rgba(0, 0.3, 0.3, 0.3) 15px 15px 15px',
        optionId: o.id,
        opacity: 1,
        targets: o.targets,
        stroke: '#22577a',
        fill: '',
        left,
        top,
        id: `source-${index}`,
        name: `source-${index}`,
        erasable: false,
        hasControls: false,
        hasBorders: false,
      });
      this._canvas.addObject(source);
      sourceList.push(source);
      index++;
    }
    return sourceList;
  };

  addTargets = async (targets: PageIcon[]) => {
    const targetList = [];
    const targetOptions = targets;
    let index = 0;
    const gradient = new fabric.Gradient({
      type: 'linear',
      coords: { x1: 0, y1: 0, x2: 200, y2: 0 },
      colorStops: [
        { offset: 0, color: ' #4350af' },
        { offset: 1, color: '#2962cb' },
      ],
    });
    const imageCoordinate = this._canvas.getBackgroundImageCoordinate();
    for (const o of targetOptions) {
      const left = imageCoordinate.imgLeft + o.x;
      const top = imageCoordinate.imgTop + o.y;
      const target = await new fabric.Rect({
        width: o.width,
        height: o.height,
        targetId: o.id,
        pageIcon: true,
        strokeWidth: 3,
        optionId: o.id,
        rx: 8,
        ry: 8,
        stroke: gradient,
        shadow: 'rgba(0, 0.3, 0.3, 0.3) 15px 15px 15px',
        fill: '',
        left,
        top,
        id: `target-${o.id}`,
        name: `target-${index}`,
        hasControls: false,
        hasBorders: false,
        erasable: false,
        evented: false,
        matchingSources: [],
      });
      this._canvas.addObject(target);
      targetList.push(target);
      index++;
    }
    return targetList;
  };

  setMatchingLines = (target: any, source: any, line: any) => {
    const canvas = this._canvas;
    if (this.activityType === this.Type.OneToOne) {
      //eğer farklı targetlarda varsa sil
      let existingLines = this.matchingItems.filter(
        (x) => x.optionId === line.optionId && x.targetId !== target.id,
      );
      // aynı targetta farklı option varsa
      const b = this.matchingItems.filter(
        (x) => x.optionId !== line.optionId && x.targetId === target.id,
      );
      existingLines = existingLines.concat(b);
      for (const deletedLine of existingLines) {
        this.matchingItems = this.matchingItems.filter(
          (x) => x.lineId !== deletedLine.lineId,
        );
        const deletedOne = canvas
          .getObjects()
          .find((x) => x.id === deletedLine.lineId);
        if (deletedOne) {
          canvas.removeObject(deletedOne);
        }
        if (deletedLine.targetId !== target.id) {
          const emptyTarget = canvas
            .getObjects()
            .find((x) => x.id === deletedLine.targetId);
          emptyTarget.set({ strokeDashArray: [0, 0] });
        }
        const emptySource = canvas
          .getObjects()
          .find((x) => x.id === deletedLine.sourceId);
        emptySource.set({ strokeDashArray: [0, 0] });
      }
    }
    const existingSources = this.matchingItems.filter(
      (x) => x.optionId === source.optionId,
    );
    if (existingSources.length === source.targets.length) {
      // ;
      // drawLine(source);
    }
    target.set({ strokeDashArray: [1, 1] });
    this.backToOrginal(source, 5);
    line.set({
      x2: target.left,
      y2: target.top + target.height / 2,
      strokeDashArray: [1, 1],
    });
    line.setCoords();
    this._canvas.canvasRenderAll();
  };
  createMatchingLine = (source: any) => {
    const color = this.getRandomColor();

    const line = new fabric.Line(
      [
        source.originalLeft + source.width,
        source.originalTop + source.height / 2,
        source.originalLeft + source.width,
        source.originalTop + source.height / 2,
      ],
      {
        id: uuid4(),
        name: 'matching-line',
        strokeWidth: 5,
        clearOnReset: true,
        pageIcon: true,
        optionId: source.optionId,
        fill: 'red',
        stroke: color,
        originX: 'center',
        originY: 'center',
        selectable: false,
        evented: false,
      },
    );
    return line;
  };

  checkPosition = async (
    source: any,
    line: any,
    x: any,
    y: any,
    playSound = true,
  ) => {
    const canvas = this._canvas;
    let isOnTarget = false;
    for (const target of this.targets) {
      // var audio = new Audio(`${process.env.PUBLIC_URL}/assets/sound/click.mp3`);
      // audio.play();
      if (target.containsPoint(new fabric.Point(x, y))) {
        if (
          !this.matchingItems.find(
            (x) => x.targetId === target.id && x.optionId === source.optionId,
          )
        ) {
          const isCorrect =
            source.targets.filter((x: any) => x.id === Number(target.optionId))
              .length !== 0;
          if (!this.pageItem?.hasCompleteButton && playSound) {
            this.playSound(isCorrect);
            if (!isCorrect) {
              break;
            }
          }
          this.matchingItems.push({
            targetId:target.id,
            sourceId:source.id,
            optionId:source.optionId,
            lineId: line.id,
            isCorrect,
          });
          this.setMatchingLines(target, source, line);
          isOnTarget = true;
          break;
        }
      }
    }
    if (!isOnTarget) {
      console.log(this.matchingItems);
      canvas.removeObject(line);
      this.backToOrginal(source, 0);
    }
  };

  backToOrginal = (source: any, stroke: any) => {
    const canvas = this._canvas;
    // Animasyon
    source.animate(
      {
        left: source.originalLeft,
        top: source.originalTop,
      },
      {
        duration: 100, // Daha uzun bir süre
        onChange: () => canvas.canvasRenderAll(),
        onComplete: () => {
          source.set({
            opacity: 1,
            strokeDashArray: [stroke, stroke],
          });
          canvas.canvasRenderAll(); // Tamamlandığında tekrar render
        },
      },
    );
  }
  onComplete = () => {
    const canvas = this._canvas;
    const objects = canvas.getObjects();
    for (const item of this.matchingItems) {
      const target = objects.find((x) => x.id === item.targetId.toString());
      const circle = drawCircle(
        target.left + target.width,
        target.top,
        10,
        item.isCorrect,
      );
      canvas.addObject(circle.circle);
      canvas.addObject(circle.iconShape);
    }
    canvas.canvasRenderAll();
    return this.matchingItems;
  };

  onReset = () => {
    this.resetOpenedAnswers();
    const canvas = this._canvas;
    const objects = canvas.getObjects();
    const lines = objects.filter((x) => x.clearOnReset === true);
    for (const line of lines) {
      canvas.removeObject(line);
    }
    for (const source of this.sources) {
      this.backToOrginal(source, 0);
    }
    for (const target of this.targets) {
      target.set('strokeDashArray', [0, 0]);
    }
    this.matchingItems = [];
    canvas.canvasRenderAll();
  };

  onShowAnswer = async () => {
    this.onReset();
    const canvas = this._canvas;
    const objects = canvas.getObjects();
    for (const source of this.sources) {
      for (const target of source.targets) {
        const t = objects.find((x) => x.id === `target-${target.id}`);
        if (t) {
          const targetCenterPoint = t.getCenterPoint();
          const line = this.createMatchingLine(source);
          canvas.addObject(line);
          this.checkPosition(
            source,
            line,
            targetCenterPoint.x,
            targetCenterPoint.y,
            false,
          );
        }
        this.addOpenedAnswers(source.optionId);
        // await timer(50)
      }
    }

    this.playSound('solve');
  };
  onShowPreviousAnswer = async () => {
    const canvas = this._canvas;
    const allObjects = canvas.getObjects();
    const showedItems = allObjects.filter((x) =>
      this.getOpenedAnswers().includes(x.optionId),
    );
    if (showedItems.length > 0) {
      const item = showedItems[showedItems.length - 1];
      const lines = allObjects.filter(
        (x) => x.clearOnReset === true && x.optionId === item.optionId,
      );
      for (const line of lines) {
        canvas.removeObject(line);
      }
      var source = this.sources.find((x) => x.optionId === item.optionId);
      if (source) {
        this.backToOrginal(source, 0);
        if (source.targets.length > 0) {
          for (const target of source.targets) {
            const tt = this.targets.find((x) => x.optionId === target.id);
            tt.set('strokeDashArray', [0, 0]);
          }
        }
      }
      this.matchingItems = this.matchingItems.filter(
        (x) => x.optionId !== item.optionId,
      );
      canvas.canvasRenderAll();
      this.removeOpenedAnswers(item.optionId);
    }
  };
  onShowNextAnswer = async () => {
    const canvas = this._canvas;
    const allObjects = canvas.getObjects();
    const notShowedItems = this.sources.filter(
      (x) =>
        !this.getOpenedAnswers().includes(x.optionId) && x.targets.length > 0,
    );
    if (notShowedItems.length > 0) {
      const item = notShowedItems[0];
      for (const target of item.targets) {
        const t = allObjects.find((x) => x.id === `target-${target.id}`);
        if (t) {
          const targetCenterPoint = t.getCenterPoint();
          const line = this.createMatchingLine(item);
          canvas.addObject(line);
          this.checkPosition(
            item,
            line,
            targetCenterPoint.x,
            targetCenterPoint.y,
          );
        }
      }
      this.playSound('solve');
      this.addOpenedAnswers(item.optionId);
    }
  };
  destroy() {
    this.resetOpenedAnswers();
    this._canvas.off('object:added');
    this._canvas.off('object:moving');
  }
  doMouseDown(o: any) {}

  doMouseMove(o: any) {}

  doMouseUp(o: any) {
    const canvas = this._canvas;
    const objects = canvas.getObjects();
    objects.forEach((obj) => {
      if (obj.pageIcon) {
        canvas.bringToFront(obj);
      }
    });

    canvas.canvasRenderAll();
  }
}

export default Matching;
